import React from "react";
import { getClosestSelectElement  } from "lib/DOMHelpers/retrievingDOMElems";
import PropTypes from "prop-types";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import * as CustomClassUtilities from "lib/CustomClassUtilities";

import './Popover.less';

const Popover = ({anchorEl, open, placement, children, handleClickAway}) => {

	var collection = document.getElementsByClassName('novselect-app extra-classy main-app');
	document.documentElement.style.setProperty(`--z-index-for-novelist-popover`, CustomClassUtilities.getZIndexFromNode(collection[0], 10000, 1001));

	return (
		<Popper placement={placement || "bottom"} open={open} anchorEl={anchorEl} container={getClosestSelectElement(anchorEl)} className='nov-popover'>
			<ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown">
				{children}
			</ClickAwayListener>
		</Popper>
	);
};

Popover.propTypes = {
	placement: PropTypes.string,
	open: PropTypes.bool,
	anchorEl: PropTypes.object,
	handleClickAway: PropTypes.func.isRequired
};

export default Popover;



// WEBPACK FOOTER //
// ./src/react/views/generic/Popover.jsx